// Hand-written, not generated: the one pager every list page shares
// (Knowledge, Tags, Snippets, Study). Same shape the old pager gave
// them — Previous, "page / total", Next, optional First/Last — with the
// self-heal on a stale page staying in the page components. #34.
import { forwardRef } from "react";
import PropTypes from "prop-types";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronsLeftIcon,
  ChevronsRightIcon,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const Pagination = forwardRef(function Pagination(
  { page, total, onChange, showEdges = false, className, ...props },
  ref,
) {
  const go = (next) => onChange(Math.min(Math.max(1, next), total));
  return (
    <nav
      ref={ref}
      aria-label="Pagination"
      data-slot="pagination"
      className={cn("flex items-center justify-center gap-1", className)}
      {...props}
    >
      {showEdges && (
        <Button
          type="button"
          variant="outline"
          size="icon"
          onClick={() => go(1)}
          disabled={page <= 1}
        >
          <ChevronsLeftIcon />
          <span className="sr-only">First page</span>
        </Button>
      )}
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={() => go(page - 1)}
        disabled={page <= 1}
      >
        <ChevronLeftIcon />
        <span className="sr-only">Previous page</span>
      </Button>
      <span
        aria-current="page"
        className="min-w-16 px-2 text-center text-sm tabular-nums text-muted-foreground"
      >
        {page} / {total}
      </span>
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={() => go(page + 1)}
        disabled={page >= total}
      >
        <ChevronRightIcon />
        <span className="sr-only">Next page</span>
      </Button>
      {showEdges && (
        <Button
          type="button"
          variant="outline"
          size="icon"
          onClick={() => go(total)}
          disabled={page >= total}
        >
          <ChevronsRightIcon />
          <span className="sr-only">Last page</span>
        </Button>
      )}
    </nav>
  );
});

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  showEdges: PropTypes.bool,
  className: PropTypes.string,
};

export { Pagination };
